( function( global, $ ) {
    "use strict";

    var _events = {
        onFormDeleteEntry: function(ev) {
            ev.preventDefault();

            var $deleteBtn = $(this);

            if ($deleteBtn.data('form-delete-entry') === 'confirmed') {
                return;
            }

            setTimeout(function() {
                if (confirm($deleteBtn.data('confirm-message'))) {
                    $deleteBtn.data('form-delete-entry', 'confirmed');

                    $deleteBtn.trigger('click');
                } else {
                    $deleteBtn.data('form-delete-entry', 'confirm');
                }
            }, 10);
        }
    };

    var $body = $('body');

    $body.on('app.ready', function(ev) {
        $body.on('click', '[data-form-delete-entry="confirm"]', _events.onFormDeleteEntry);
    });

}( window.groots, jQuery ));
